import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ImplementerMergePage } from './implementer-merge-page';
import { ImplementerMergeWizardComponent } from '../implementer-merge-wizard/implementer-merge-wizard.component';
import { ImplementerMergeWizardStepOneComponent } from '../implementer-merge-wizard-step-one/implementer-merge-wizard-step-one';
import { ImplementerMergeWizardStepTwoComponent } from '../implementer-merge-wizard-step-two/implementer-merge-wizard-step-two';
import { ImplementerMergeWizardStepThreeComponent } from '../implementer-merge-wizard-step-three/implementer-merge-wizard-step-three';
import { ArchwizardModule } from 'angular-archwizard';
import { DirectivesModule } from '../../../../directives/directives.module';
import { FoundationModule } from '../../../../_foundation/foundation.module';

@NgModule({
  declarations: [
    ImplementerMergePage,
    ImplementerMergeWizardComponent,
    ImplementerMergeWizardStepOneComponent,
    ImplementerMergeWizardStepTwoComponent,
    ImplementerMergeWizardStepThreeComponent,
  ],
  imports: [
    DirectivesModule,
    FoundationModule,
    IonicPageModule.forChild(ImplementerMergePage),
    ArchwizardModule,
  ],
  exports: []
})
export class ImplementerMergePageModule {
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-merge/implementer-merge/implementer-merge-page.module.ts